import React from "react";
import { Formik } from "formik";
import {
  DeliveryMethodFormValidation,
  DineInMethodFormValidation,
} from "./Validation";
import fetchData from "../../../utils/api";
import { AccordionContent } from "../../../components/ui/accordion";
import { Label } from "../../../components/ui/label";
import { Button } from "../../../components/ui/button";
import { Icons } from "../../../components/icons";
import FormError from "../../../components/FormError";
import { Input } from "../../../components/ui/input";
import { useTranslation } from "react-i18next";

export default function DinInCart({
  cartList,
  authToken,
  id,
  restaurantDetail,
  handleCartList,
  handleAccordionClick,
}) {
  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  const { t } = useTranslation();

  return (
    <div>
      <Formik
        enableReinitialize={true}
        initialValues={{
          table_no: cartList?.dineIn?.table_no
            ? cartList?.dineIn?.table_no
            : "",
        }}
        validationSchema={DineInMethodFormValidation}
        onSubmit={async (values) => {
          setIsLoading(true);
          const cachedCart = localStorage.getItem("cart");
          try {
            const body: any = {
              cart_id: cachedCart,
              table_no: values.table_no,
            };
            const res = await fetchData({
              url: "cart/dine-in",
              method: "POST",
              body,
              token: authToken,
            });
            if (res.status_code === 200) {
              setIsLoading(false);
              handleCartList();
              handleAccordionClick("item-4");
            }
          } catch (error) {
            console.log("error", error);
          }
        }}
      >
        {({ errors, touched, setFieldValue, values, handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <AccordionContent className="grid p-2 gap-2">
              <div className="grid gap-2">
                <div className="grid gap-2 w-full">
                  <Label className="text-left" htmlFor="table_no">
                    {t("cart.table_number.form.table_number")}
                  </Label>
                  <div>
                    <Input
                      min={1}
                      type="number"
                      id="table_no"
                      placeholder={t(
                        "cart.table_number.form.table_number_placeholder"
                      )}
                      value={values.table_no}
                      onChange={(e: any) => {
                        setFieldValue("table_no", e.target.value, true);
                      }}
                      disabled={isLoading}
                    />
                    {errors.table_no && touched.table_no ? (
                      <FormError msg={t(errors.table_no as string)} />
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="flex justify-end w-full">
                <Button disabled={isLoading} type="submit">
                  {isLoading && (
                    <Icons.spinner className="mr-2 h-4 w-4 animate-spin" />
                  )}
                  {t("save")}
                </Button>
              </div>
            </AccordionContent>
          </form>
        )}
      </Formik>
    </div>
  );
}
